/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles((theme) => (
    {
        shopByFilterTitle: {
            '&.shop-by-filter-title': {
                fontSize: 30,
                textAlign: 'center !important',
                fontFamily: 'BebasNeue',
                [theme.breakpoints.down(400)]: {
                    fontSize: 28,
                },
            },
        },
        shopBySection: {
            '&.shopBySectionWrapper': {
                '& .root': {
                    flex: '0 0 33.3333%',
                    width: '33.33333%',
                    [theme.breakpoints.down(768)]: {
                        flex: '0 0 100%',
                        width: '100%',
                    },
                },
                '& .shop-by-section': {
                    boxShadow: '0px 3px 11px #00000010',
                    padding: '5%',
                    paddingBottom: '2%',
                    textAlign: 'center',
                    '& h4': {
                        marginTop: 0,
                        marginBottom: '0.5rem',
                    },
                },
                '& .filter-title': {
                    font: 'normal normal 30px/37px BebasNeue',
                    letterSpacing: '1.6px',
                },
                '& .slider-margin': {
                    marginRight: '1% !important',
                    marginLeft: '1% !important',
                    marginBottom: '8% !important',
                },
                '& .zero-padding': {
                    paddingLeft: '2%',
                    paddingRight: '2%',
                    [theme.breakpoints.down(768)]: {
                        paddingLeft: '0',
                        paddingRight: '0',
                    },
                },
                '& .shop-by-option': {
                    backgroundColor: '#F2F2F2',
                    fontFamily: '"BebasNeue", "Hind", sans-serif',
                    fontSize: '0.750rem',
                    letterSpacing: '1.5px',
                    paddingBottom: '13px',
                    marginBottom: '18px',
                    borderRadius: '5px',
                    marginTop: '0.5rem',
                    '&:hover': {
                        backgroundColor: '#B9E529',
                        cursor: 'pointer',
                    },
                },
                '& .content': {
                    font: 'normal normal 600 14px/21px  "Hind", sans-serif',
                    margin: 'auto',
                    color: 'black',
                    paddingTop: '6% !important',
                    [theme.breakpoints.down(768)]: {
                        paddingTop: '3% !important',
                    },
                },
                '& .icon': {
                    height: '57px',
                    [theme.breakpoints.down(768)]: {
                        height: '50px',
                    },
                },
                '& .slick-dots': {
                    bottom: '-25px !important',
                },
                '& .slick-dots li button': {
                    '&:before': {
                        borderRadius: '75px',
                        backgroundColor: 'white',
                        content: "' ' !important",
                        border: '1px solid grey',
                        height: '10px !important',
                        width: '10px !important',
                        opacity: '100 !important',
                    },
                },
                '& .slick-active button': {
                    borderRadius: '75px',
                    content: "' ' !important",
                    height: '20px !important',
                    width: '20px !important',
                    '&:before': {
                        height: '10px !important',
                        width: '10px !important',
                        backgroundColor: '#707070 !important',
                        border: '1px solid grey',
                    },
                },
                '& .slick-track': {
                    [theme.breakpoints.down('414')]: {
                        marginRight: 'unset',
                        /* transform: 'unset !important', */
                    },
                },
            },
        },
    }
));

export default styles;
